import { Suspense } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import { Layout } from "@/components/Layout";
import { CasesGridLazy } from "@/components/cases/CasesGridLazy";
import { casesByTagQueryOptions } from "@/lib/public-content.queries";

const SITE_ORIGIN = "https://creategy.de";

export const Route = createFileRoute("/buergermeisterwahl-projekte")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      casesByTagQueryOptions("buergermeisterwahl"),
    ),
  head: () => {
    const title = "Bürgermeisterwahl Projekte – creategy";
    const description =
      "Ausgewählte Projekte und Referenzen aus Bürgermeisterwahlkämpfen, die creategy strategisch und kreativ begleitet hat.";
    const url = `${SITE_ORIGIN}/buergermeisterwahl-projekte`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  errorComponent: () => (
    <Layout>
      <section className="mx-auto max-w-3xl px-6 md:px-12 section-y text-center">
        <h1 className="heading-h1">Projekte konnten nicht geladen werden.</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Bitte versuchen Sie es später erneut.
        </p>
      </section>
    </Layout>
  ),
  notFoundComponent: () => (
    <Layout>
      <section className="mx-auto max-w-3xl px-6 md:px-12 section-y text-center">
        <h1 className="heading-h1">Seite nicht gefunden.</h1>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold underline transition-opacity hover:opacity-80"
        >
          Zur Startseite
          <ArrowUpRight className="h-4 w-4" aria-hidden />
        </Link>
      </section>
    </Layout>
  ),
  component: BuergermeisterwahlProjektePage,
});

function BuergermeisterwahlProjektePage() {
  return (
    <Layout>
      <section className="bg-secondary/40">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 section-y">
          <div>
            <h1 className="heading-h1 text-primary">
              Bürgermeisterwahl – Projekte
            </h1>
            <p className="mt-4 text-base leading-relaxed text-muted-foreground">
              Ausgewählte Kampagnen aus Bürgermeister- und Oberbürgermeister­wahlen,
              die wir strategisch und kreativ begleitet haben.
            </p>
          </div>

          <Suspense
            fallback={
              <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-3">
                {Array.from({ length: 6 }).map((_, i) => (
                  <li
                    key={i}
                    aria-hidden
                    className="h-[400px] animate-pulse rounded-lg border border-border bg-primary/10"
                  />
                ))}
              </ul>
            }
          >
            <CasesGridLazy tag="buergermeisterwahl" />
          </Suspense>
        </div>
      </section>
    </Layout>
  );
}
